interface AuthSessionResult {
  readonly data: {
    readonly session?: {
      readonly token?: string | null;
    } | null;
  } | null;
  readonly error: {
    readonly message?: string;
  } | null;
}

export interface AuthSessionClient {
  getSession(): Promise<AuthSessionResult>;
}

export class NeonSessionTokenProvider {
  constructor(private readonly auth: AuthSessionClient) {}

  async getToken(): Promise<string> {
    // This SDK version injects set-auth-jwt into the session and caches it until
    // expiry. Its /token endpoint shares that cache and may return a session DTO.
    const { data, error } = await this.auth.getSession();
    if (error) throw new Error(error.message ?? 'Could not obtain an authentication token.');

    const token = data?.session?.token;
    if (typeof token !== 'string' || !token) {
      throw new Error('Could not obtain an authentication token.');
    }
    if (!/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token)) {
      throw new Error('Neon Auth did not provide a session JWT. Check access to the set-auth-jwt response header.');
    }
    return token;
  }
}
